'use client';

import { Button } from '@shared/components/shadcn';
import { Close } from '@shared/icons';
import { useTranslations } from 'next-intl';
import type { UseEducationalTutorialReturn } from '../../hooks/useEducationalTutorial';

type EducationalTutorialCloseButtonProps = {
  tutorial: UseEducationalTutorialReturn;
  className?: string;
};

function EducationalTutorialCloseButton({
  tutorial,
  className = 'absolute top-3 right-3 h-8 w-8 z-3 rounded-full bg-button-background-inverse dark:bg-button-background hover:bg-button-background-hover-inverse dark:hover:bg-button-background-hover focus-visible:outline-none focus-visible:ring-[0px] flex items-center justify-center',
}: EducationalTutorialCloseButtonProps) {
  const t = useTranslations('global_dialogs.educational');

  return (
    <Button
      variant="primary"
      size="icon-m"
      // eslint-disable-next-line react-hooks/refs
      ref={tutorial.closeButtonRef}
      className={className}
      data-track-name="Close"
      aria-label={t('actions.close')}
      // eslint-disable-next-line react-hooks/refs
      onClick={tutorial.closeDialog}
    >
      <Close size="small" className="text-foreground dark:text-foreground-inverse" />
      <span className="sr-only">{t('actions.close')}</span>
    </Button>
  );
}

export { EducationalTutorialCloseButton };
